import type { VehiclePaymentWizardContext } from 'Components/pages/VehiclePayment/VehiclePayment.types';
import { useWizard } from 'Components/shared/Wizard/Wizard.hooks';

export const usePaymentsWizard = useWizard<VehiclePaymentWizardContext>;
